export enum NotifyIcon {
    information = <any>'fa-info-circle text-primary',
    warning = <any>'fa-exclamation-triangle text-warning',
    error = <any>'fa-times-circle text-danger',
}
